import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import { contacto } from '../models/contacto';
import {contactoMensaje} from "../models/contactoMensaje";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class ContactMessageService {

  private contacto: contacto;

  constructor(private http: HttpClientService) { }

  setContacto(contacto: contacto) {
    this.contacto = contacto;
  }

  getContacto() {
    return this.contacto;
  }

  public getByIdContacto(idContacto) {
    let params = new HttpParams().set("idContacto", idContacto);
    return this.http.getWithParams('/contactomensaje/getbycontacto', params);
  }

  public new(contactoMensaje: contactoMensaje) {
    return this.http.post('/contactomensaje/new', contactoMensaje);
  }

}
